import React from 'react'
import PropTypes from 'prop-types'
import { IndexTemplate } from '../../templates/index-Template.js'

const IndexPagePreview = ({ entry, getAsset}) => {
  const data = entry.getIn(['data']).toJS()
  console.log(data)

  if (data) {
    data.banner.image = getAsset(data.banner.image).url;
    data.qualities.map((item, i) => {
      data.qualities[i].image = getAsset(item.image).url
    });
    data.mindestangaben.image = getAsset(data.mindestangaben.image).url

    data.umlageschluessel.list.map((item, i) => {
      data.umlageschluessel.list[i].image = getAsset(item.image).url
    });
    
    data.pagebreak.image = getAsset(data.pagebreak.image).url;


    return (
      <IndexTemplate
        banner = { data.banner }
        intro = { data.intro }
        qualities = { data.qualities }
        nebenkosten = { data.nebenkosten }
        mindestangaben = { data.mindestangaben }
        umlageschluessel = { data.umlageschluessel }
        erstgespraech = { data.erstgespraech }
        pagebreak = { data.pagebreak }
        faq = { data.faq }
        contact = { data.contact }
        buttonmenu = { data.buttonmenu }
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

IndexPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default IndexPagePreview